/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

require('components/common/table-data/table-data');

const store = require('appVuex/store');
const ajaxHttp = require('appUtil/ajaxHttp');
const tip = require('components/base/pop/tip');
const { apiPath } = require('appService/api');
const { dropMenu: dropMenuEvent } = require('components/config/event.json');

require('./app-feedback.scss');
const template = require('./app-feedback.tpl');

const AppFeedback = {
	name: "app-feedback",

	template,

	data() {
		return {
			placeItem: "输入反馈内容",
			thItems: ["序号", "用户名", "性别", "手机号", "反馈内容", "反馈时间", "版本信息", "状态", "操作"],
			url: apiPath.user.appFeedBack,
			remarkMessage: '',
			lineIndex: ''
		}
	},

	methods: {
		qurryFeedBack() {
			let queryParams = {
        keyType: this.$refs.ktypeDropmenu.val(),
        keyWord: this.$refs.kwordInputbox.val()
      };
    	this.$refs.tableData.query(queryParams).fetch();
		},
		remark(index) {
			this.lineIndex = index;
			this.$refs.remarkInput.val('');
			this.$refs.remarkPop.show();
		},
		saveRemark() {
			let inputLen = (this.$refs.remarkInput.val()).toString().length;
			if( !this.$refs.remarkInput.val() ) {
				tip("请输入备注信息");
			} else if(inputLen > 120){
				tip("输入内容不能超过120个字符！");
			} else {
				let url = apiPath.user.addRemark;
				let queryParams = {
					feedbackId: this.$refs.tableData.trItems[this.lineIndex].id,
					remark: this.$refs.remarkInput.val()
				}
				ajaxHttp(url, {
					"type": "post",
					"data": queryParams
				}).then((res) => {
					this.$refs.tableData.trItems[this.lineIndex].state = res.data.state;
					this.$refs.tableData.trItems[this.lineIndex].remark = res.data.remark;
					this.$refs.remarkPop.hide();
					tip("已添加备注信息！")
				}).catch((res) => {
					tip(res.error);
				})
			}
		},
		queryRemark(index) {
			this.$refs.showremarkPop.show();
			this.remarkMessage = this.$refs.tableData.trItems[index].remark;
		}
	},

	events: {
		[dropMenuEvent.menu.change](){
			if ( this.$refs.ktypeDropmenu.val() === 1) {
				this.placeItem = "输入反馈内容"
			} else if ( this.$refs.ktypeDropmenu.val() === 2 ) {
				this.placeItem = "输入手机号"
			} else if ( this.$refs.ktypeDropmenu.val() === 3 ) {
				this.placeItem = "输入评论用户名"
			}
		}
	}
}

module.exports = AppFeedback;



// WEBPACK FOOTER //
// ./src/appBackend/components/page/user/app-feedback/app-feedback.js